export default __webpack_public_path__ + "static/model360-amsterdam-790bfa476c1a244275e6637a305f7f78.png";